import React from "react";
import HinbanEntryGridAr from "../../components/HinbanEntryGridAr";

// 品番原価セクション(ヘッダ帯・明細グリッド・サマリ表)の描画をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createGenkaRenderer(deps) {
    const {
        DicVal,
        ListRowValueChanged,
        ListValueChanged,
        buildHinbanGenkaFixedColumns,
        buildHinbanGenkaSaveRows,
        buildHinbanGenkaSummaryRows,
        buildWashGridFunctionRef,
        columninfo,
        columns,
        deriveGenkaPatternFromEntry,
        ensureGridColRef,
        ensureGridDataRef,
        ensureHinbanGenkaGridDataRef,
        entrydataRef,
        findGenkaCurrencyLayoutMeta,
        fixedHinbanGenkaDisplayRows,
        fnc,
        formid,
        genkaCurrency,
        genkaCurrencyDisplayLabel,
        genkaCurrencyOptions,
        genkaPattern,
        genkaPatternLabelByNo,
        handleHinbanGenkaCurrencyChanged,
        isEmpty,
        isGenkaCurrencyEditableByLayout,
        onFirstDataRendered,
        resolveGenkaCurrencyFromEntry,
        shouldForceGenkaCurrencyJpy
    } = deps;

    function renderHinbanGenkaHeader() {
        const patternDisplay = String(genkaPattern ?? '').trim() || genkaPatternLabelByNo(deriveGenkaPatternFromEntry(entrydataRef.current));
        const currencyHeaderLabel = String(DicVal(findGenkaCurrencyLayoutMeta(), 'columnnm', '通貨単位') ?? '通貨単位');
        const currencyEditable = isGenkaCurrencyEditableByLayout() && !shouldForceGenkaCurrencyJpy(entrydataRef.current);
        const currencySelectable = currencyEditable && Array.isArray(genkaCurrencyOptions) && genkaCurrencyOptions.length !== 0;
        const currencyRaw = String(!isEmpty(genkaCurrency) ? genkaCurrency : resolveGenkaCurrencyFromEntry(entrydataRef.current));
        const currencyDisplay = genkaCurrencyDisplayLabel(currencyRaw);
        return (
            <div className="hinban-genka-header">
                <div className="hinban-genka-header-left">
                    <div className="hinban-genka-field">
                        <div className="hinban-genka-field-label">{'原価パターン'}</div>
                        <div className="hinban-genka-field-value hinban-genka-field-value--last hinban-genka-field-value--pattern">{patternDisplay}</div>
                    </div>
                    <div className="hinban-genka-field">
                        <div className="hinban-genka-field-label">{currencyHeaderLabel}</div>
                        <div className="hinban-genka-field-value hinban-genka-field-value--last">
                            {currencySelectable ? (
                                <select value={genkaCurrency} onChange={(e) => handleHinbanGenkaCurrencyChanged(e.target.value)} className="hinban-genka-currency-select">
                                    {genkaCurrencyOptions.map((v) => <option key={'hinban_genka_cur_' + v} value={v}>{genkaCurrencyDisplayLabel(v)}</option>)}
                                </select>
                            ) : (
                                <div className="hinban-genka-currency-text">{currencyDisplay}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="hinban-genka-header-right">
                    <div className="hinban-genka-total-label">
                        <span className="hinban-genka-total-bar"></span>
                        <span>{'合計'}</span>
                    </div>
                </div>
            </div>
        );
    }
    function renderHinbanGenkaDetailGrid(panelInfo) {
        const dataRef = ensureHinbanGenkaGridDataRef(panelInfo);
        return (
            <div className="hinban-kakousiji-genka-grid hinban-genka-detail-grid">
                <HinbanEntryGridAr
                    id={fnc.current.GridID(panelInfo)}
                    entrydataRef={entrydataRef}
                    dataRef={dataRef}
                    columnRef={ensureGridColRef(panelInfo)}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={buildWashGridFunctionRef(panelInfo)}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                    RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
                    panel={panelInfo}
                    QuerySetColumn={buildHinbanGenkaFixedColumns}
                    displayRowDataBuilder={(rows) => fixedHinbanGenkaDisplayRows(rows)}
                    saveRowDataMapper={(rows, previousRows) => buildHinbanGenkaSaveRows(rows, previousRows)}
                    AutoAddRow={false}
                    rowDrag={false}
                    hideRowNumbers={true}
                    forceAutoHeight={true}
                />
            </div>
        );
    }
    function renderHinbanGenkaSummaryTable(panelInfo) {
        const rows = buildHinbanGenkaSummaryRows(ensureGridDataRef(panelInfo).current);
        return (
            <div className="hinban-genka-summary">
                <table className="hinban-genka-summary-table">
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.rowid}>
                                <td className="hinban-genka-summary-label">{row.label}</td>
                                <td className="hinban-genka-summary-value">{row.value}</td>
                                <td className="hinban-genka-summary-value">{row.value2}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
    function renderHinbanGenkaSection(panelInfo, filteredColumnInfo, filteredColumns) {
        ensureHinbanGenkaGridDataRef(panelInfo);
        return (<React.Fragment><div>{renderHinbanGenkaHeader()}<div className="hinban-genka-section-body">{renderHinbanGenkaDetailGrid(panelInfo)}{renderHinbanGenkaSummaryTable(panelInfo)}</div></div></React.Fragment>);
    }

    return {
        renderHinbanGenkaHeader,
        renderHinbanGenkaDetailGrid,
        renderHinbanGenkaSummaryTable,
        renderHinbanGenkaSection
    };
}
